export default __webpack_public_path__ + "static/media/speech.8744f9d6.svg";